export const PauseSvg = () => {
  return (
    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0L14 10L0 20V0Z" fill="black" />
    </svg>
  );
};
